import { Outlet, createFileRoute } from '@tanstack/react-router';

import { ProductionPlannerViewToggle } from '../../features/production-planner/production-planner-view-toggle';

export const Route = createFileRoute('/production-planner')({
  staticData: {
    permissionSection: 'planner',
    section: 'Planner',
    breadcrumb: 'Production Planner',
    layout: 'full-height',
    // Shown top-right of the header on every /production-planner route (Grid,
    // Timeline) — declared once here, inherited by all children.
    headerActions: () => <ProductionPlannerViewToggle />,
  },
  component: ProductionPlannerLayout,
});

function ProductionPlannerLayout() {
  return <Outlet />;
}
